<div class="main-layout" [class.is-pinned]="isPinned()">
  <crm-sidebar [pinned]="isPinned()" (togglePin)="togglePin()" />

  <main class="main-layout__content">
    <router-outlet></router-outlet>
  </main>
</div>
